import { buildLoginUrl } from '../../../shared/utils/returnUrl';
import backendApi from '../../../services/base.config';
import { setToken } from '../../../services/auth/auth.slice';
import { setProject } from '../../../services/common/common.slice';

const ApplicationLogout = async (dispatch, navigate, returnUrl) => {
  try {
    dispatch(backendApi.util.resetApiState());
    dispatch(setToken(null));
    localStorage.removeItem('sessionExpired');
    localStorage.removeItem('tabSessionIDs');
    localStorage.removeItem('aid');
    localStorage.removeItem('role');
    localStorage.removeItem('uuid');
    localStorage.removeItem('emailId');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('token');
    localStorage.removeItem('intraTabSessionIDs');
    localStorage.removeItem('userType');
    dispatch(setProject(''));
    navigate(buildLoginUrl(returnUrl));
  } catch (error) {
    // console.log(error);
  }
};

export default ApplicationLogout;
